<template>
  <section
    class="
      $color/background:membership:3
      $motion/transition:max-height:curve:ease-in-out
      $motion/transition:max-height:duration:300ms
      color/background
      layout/border:top:2pt
      layout/height:max
      layout/width:100%
      layout/z-index:2
      motion/transition
      @768/layout/border:top:3pt
    "
    style="
      will-change: max-height;
    "
    :style="{
      '--layout--height--max': `${maxHeight}px`,
    }"
    >
    <div
      class="
        $color/background:membership:3
        color/background
        layout/padding:bottom:page
        layout/width:100%
        layout/wrapper
      "
      >
      <div
        ref="peekCutoff"
        class="
          $typography/size:22pt
          layout/grid:1
          layout/grid:gap:page
          layout/padding:bottom:page
          layout/padding:top:page
          layout/width:100%
          @360/$typography/size:24pt
          @480/$typography/size:18pt
          @480/layout/grid:2
          @600/$typography/size:24pt
          @768/layout/padding:bottom:baseline
          @768/layout/padding:top:baseline
          @1024/$typography/size:32pt
          @1280/$typography/size:40pt
        "
        style="
          --480--layout--grid--template--columns:minmax(0, 1fr) max-content;
        "
        >
        <h2 class="typography">
          <span
            class="layout/block balance-text"
            v-html="heading"
          />
        </h2>
        <slot name="cta" />
      </div>
      <membershipCard :membership-base-url="membershipBaseUrl" :gtm-context="gtmContext" @onButtonFocus="onButtonFocus" />
    </div>
  </section>
</template>

<script>
  import iconLink from './../shared/links/link';
  import i18n from '../../utils/i18n';
  import membershipCard from './membership-card';
  import throttle from 'lodash/throttle';

  export default {
    components: {
      membershipCard,
      iconLink
    },
    props: {
      gtmContext: { type: String, required: true },
      membershipBaseUrl: { type: String, required: true },
      heading: { type: String, required: true },
    },
    data() {
      return {
        i18n: new i18n(),
        heightCollapsed: 0,
        heightExpanded: 0,
        expanded: false,
        heightFadeDefault: 192, // 4 * var(--page-spacing)
        heightFade: 0,
        viewportOffset: 0,
      };
    },
    computed: {
      maxHeight: function() {
        return this.expanded ? this.heightExpanded: this.heightCollapsed;
      },
    },
    mounted() {
      this.footerOverlayEl      = document.querySelector('[data-footer-overlay]');
      this.footerOverlayFadeEl  = document.querySelector('[data-footer-overlay-fade]');
      this.previewCutoffEl      = document.querySelector('[data-preview-cutoff]');

      this.preventUserInteractions();
      this.updateBanner();

      window.addEventListener("scroll", throttle(this.toggleExpand, 150));
      window.addEventListener("resize", throttle(this.updateBanner, 150));
    },
    destroyed() {
      window.removeEventListener("scroll", this.toggleExpand);
      window.removeEventListener("resize", this.updateBanner);
    },
    methods: {
      preventUserInteractions: function() {
        this.previewCutoffEl.style.pointerEvents = 'none';
        this.previewCutoffEl.style.userSelect = 'none';
      },
      toggleExpand: function() {
        if (this.isInViewport(this.footerOverlayFadeEl)) {
          this.expanded = true;
        } else {
          this.expanded = false;
        }
      },
      isInViewport: function(element) {
        var adjustedViewport = (window.innerHeight || document.documentElement.clientHeight) - this.heightCollapsed;
        return element.getBoundingClientRect().bottom + this.viewportOffset <= adjustedViewport;
      },
      updateBanner: function() {
         new Promise(() => {
          this.calculateHeights();
        })
        .then(this.adjustHeightFade())
        .then(this.adjustFooterOverlay())
        .then(this.adjustBannerMargins())
        .then(this.toggleExpand());
      },
      calculateHeights: function() {
        this.heightContentBlock = this.previewCutoffEl.offsetParent.clientHeight - this.previewCutoffEl.offsetTop;
        this.heightCollapsed    = this.$refs.peekCutoff.clientHeight;
        this.heightExpanded     = this.$refs.peekCutoff.parentElement.clientHeight;
      },
      adjustBannerMargins: function() {
        const viewportHeight = window.innerHeight;
        const documentHeight = document.body.offsetHeight;
        if (viewportHeight > documentHeight) {
          this.$el.style.marginBottom = `${viewportHeight - documentHeight}px`;
        }
      },
      adjustHeightFade: function() {
        if (this.heightContentBlock < this.heightFadeDefault) {
          this.heightFade = this.heightContentBlock;
        } else {
          this.heightFade = this.heightFadeDefault;
        }
        this.footerOverlayFadeEl.style.setProperty('--height-fade', `${this.heightFade}px`);
      },
      adjustFooterOverlay: function() {
        const maxHeight = this.heightExpanded + this.heightFade;

        // Case: ContentBlock < BannerExpanded
        if (this.heightContentBlock <= this.heightExpanded) {
          this.footerOverlayEl.style.height     = `${maxHeight}px`;
          this.footerOverlayEl.style.marginTop  = `-${this.heightContentBlock}px`;
          this.viewportOffset                   = -this.heightExpanded;

        // Case: ContentBlock > BannerExpanded
        } else {
          this.footerOverlayEl.style.height     = `${maxHeight}px`;
          this.footerOverlayEl.style.marginTop  = `-${maxHeight}px`;
          this.previewCutoffEl.style.maxHeight  = `${maxHeight}px`;
          this.previewCutoffEl.style.overflow   = 'hidden';
          this.viewportOffset                   = -this.heightExpanded;
        }
      },
      onButtonFocus() {
        this.expanded = true;
      }
    },
  };
</script>
